import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { searchText } from '../../actions/SearchActions';
import {Container, Row, Col, Button, Card, CardImg, CardTitle} from 'reactstrap';
import Banner from "../Banner/Banner";
import CategoryGames from "../CategoryGames/CategoryGames";
import Swiper from 'react-id-swiper';
import StarRatingComponent from 'react-star-rating-component';
import { messages } from '../../constants/messages';
import { messages_ar } from '../../constants/messages_ar';
import { messages_kk } from '../../constants/messages_kk';
import { messages_fr } from '../../constants/messages_fr';
import { messages_sv } from '../../constants/messages_sv';
import { messages_no } from '../../constants/messages_no';
import { messages_vi } from '../../constants/messages_vi';
import { messages_tr } from '../../constants/messages_tr';
import { messages_it } from '../../constants/messages_it';
import { messages_es } from '../../constants/messages_es';
import { messages_cy } from '../../constants/messages_cy';
import { messages_de } from '../../constants/messages_de';
import { messages_el } from '../../constants/messages_el';
import { messages_ro } from '../../constants/messages_ro';
import { messages_cz } from '../../constants/messages_cz';
import { messages_pt } from '../../constants/messages_pt';
import { messages_lt } from '../../constants/messages_lt';
import * as vars from '../../constants/variables';
import { showMessage } from '../../actions/FlashMessageActions';
import { getGames, getFavouriteGames, setFavouriteGames } from "../../actions/GamesActions";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import CategoryList from '../CategoryList/CategoryList';
import { console_log, appendUid } from "../../utils/helper";
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { sendData } from '../../analytics/sendData';
import Wallpapers from './../wallpapers/wallpaper'
import Videos from './../UploadVideos/video'
import { isGamiclub } from '../../constants/isGamiclub';
import { textContentIDRoblox, textContentIDSquidGames, textContentShopee } from "../../constants/texts";
import { videos_es, videos_kw, videos_no, videos_qa, videos_ae, videos_eg, videos_rs, videos_gmn, videos_za_ci, videos_cz, videos_za } from './../../constants/videos'
import TextModal from '../TextModal/textModal';
import { isGameflares, isGamiway } from '../../constants/productCondition';

var arabicDomain ,
malasiyaDomain,
kazakhDomain ,
swedishDomain,
frenchDomain,
belgiumDomain,
norwayDomain,
vietnamDomain,
turkeyDomain ,
italianDomain ,
spanishDomain ;
let msg = {};


class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gameType: '',
            switcherState: false,
            loading:true
        };
        this.openGame = this.openGame.bind(this);
        this.toggleSwitcher = this.toggleSwitcher.bind(this);
        this.changeDomain = this.changeDomain.bind(this);
    }

    componentWillMount() {
        if(this.props.games.games.length <= 0){
        }
        if (this.props.history.location.pathname.split('/')[2] == 'html') {
            this.setState({
                gameType: 'html5'
            });
            sendData('', '', 'html5', 'viewed', {page: 'html5 home'});
        } else if (this.props.history.location.pathname.split('/')[2] == 'android') {
            this.setState({
                gameType: 'android'
            });
            sendData('', '', 'android', 'viewed', {page: 'android home' });
        } else if (this.props.history.location.pathname.split('/')[2] == 'video' && (isGamiclub || config.subDomain === 'za' || config.subDomain === 'kw' || config.subDomain === 'pt')) {
            this.setState({
                gameType: 'video'
            });
            sendData('', '', 'video', 'viewed', {page: 'video home' });
        } else {
            this.props.history.push("/login")
        }
        this.props.searchText('');
        if (this.props.categories.categories) {
            this.setState({ categoriesTranslated: true })

        }
        
    }

    componentDidMount() {
        if (this.props.categories.categories) {
            this.setState({ categoriesTranslated: true })

        }
        window.scrollTo(0, 0);
    }
    changeDomain() {
        arabicDomain = (config.lang == 'ar') ? true : false;
        kazakhDomain = (config.lang == 'kk') ? true : false;
        swedishDomain = (config.lang == 'sv') ? true : false;
        frenchDomain = (config.lang == 'fr') ? true : false;
        belgiumDomain = (config.lang == 'be') ? true : false;
        norwayDomain = (config.lang == 'no') ? true : false;
        vietnamDomain = (config.lang == 'vi') ? true : false;
        turkeyDomain = (config.lang == 'tr') ? true : false;
        spanishDomain = (config.lang == 'es') ? true : false;
        italianDomain = (config.lang == 'it') ? true : false;
        malasiyaDomain = (config.country == 'my') ? true : false;

        switch (config.lang) {
            case 'ar': msg = messages_ar;
                break;
            case 'kk': msg = messages_kk;
                break;
            case 'fr': msg = messages_fr;
                break;
            case 'sv': msg = messages_sv;
                break;
            case 'no': msg = messages_no;
                break;
            case 'vi': msg = messages_vi;
                break;
            case 'tr': msg = messages_tr;
                break;
            case 'es': msg = messages_es;
                break;
            case 'it': msg = messages_it;
                break;
            case 'cy': msg = messages_cy;
                break;
            case 'de': msg = messages_de;
                break;
            case 'el': msg = messages_el;
                break;
            case 'ro': msg = messages_ro;
                break;
            case 'cs': msg = messages_cz;
                break;
            case 'pt': msg = messages_pt;
                break;
            case 'lt': msg = messages_lt;
                break;
            default: msg = messages;
                break;
        }
    }

    toggleSwitcher(e) {
        this.setState({
            switcherState: e.target.checked
        });
        this.getFavouriteGames();
    }

    getFavouriteGames() {
        axios.get(vars.BASE_URL+'/getFavorites?uid='+this.props.access.uid)
            .then((response) => {
                if (response.data.success) {
                    this.props.getFavouriteGames(response.data);
                }
            })
            .catch((error) => {
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.history.location.pathname.split('/')[2] == 'html') {
            this.setState({
                gameType: 'html5'
            });
        } else if (nextProps.history.location.pathname.split('/')[2] == 'android') {
            this.setState({
                gameType: 'android'
            });
        } else if (nextProps.history.location.pathname.split('/')[2] == 'video') {
            this.setState({
                gameType: 'video'
            })
        }
    }
       openGame(game, e) {
        e.preventDefault()
        if (e.target.classList.contains('isFavorite')) {
            let pEl;
            if(this.state.switcherState == true){
                 pEl= ReactDOM.findDOMNode(this.refs['star'+game.gameId]);
            }
            else{
                pEl=document.getElementById('fav'+game.gameId)
            }
            let _check = !pEl.checked;
            let data = {
                uid: this.props.access.uid,
                gameId: game.gameId,
                isFavorite: _check//!game.isFavorite
            };

           let allGames = this.props.games.games,
                gameIndex = this.props.games.games.findIndex((g) => g.gameId == game.gameId),
                favGameIndex = this.props.games.favoriteGames.findIndex((g) => g.gameId == game.gameId),
                favoriteGame = this.props.games.favoriteGames;


            allGames[gameIndex].isFavorite = !game.isFavorite;

            if (!game.isFavorite) {
                if (favGameIndex > -1) {
                    favoriteGame.push(game);
                }

            } else {
                favoriteGame.splice(favGameIndex, 1);

            }

            this.props.setFavouriteGames({
                games: allGames,
                favoriteGames: favoriteGame
            });

            if(_check){
                this.props.showMessage({
                    message: msg.addToFavorites,
                    type: true
                });
            }else{
                this.props.showMessage({
                    message: msg.removeFromFavorites,
                    type: false
                });
            }
            sendData(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
            axios.post(vars.BASE_URL+'/favorite', data)
                .then((response) => {
                    if(response.status){

                        if(this.state.switcherState == true) {
                            this.getFavouriteGames();
                        }
                        else{
                            pEl.checked = _check;
                        }

                    }
                })
                .catch((error) => {
                    console_log(error);
                });
        } else if (e.target.tagName != 'INPUT') {
            this.props.history.push(appendUid('/detail/' + game.gameId, this.props.access.uid));
        }
    }

    render() {
        console.log('isGamiway===>',config.subDomain)
        this.changeDomain();
        
        let bannerData;
        let htmlBannerDataMobile;
        let htmlBannerData;
        if (this.state.gameType == 'html5') {
            htmlBannerData = [
                    {
                        //imgUrl: './img/html5-banner.jpg',
                        imgUrl: './img/my-html5-banner-new.png',
                        offer: null,
                        game_name: '',
                        category_name: '',
                        //id: 34
                        id: 26
                    }
                ];
                htmlBannerDataMobile = [
                    {
                        //imgUrl: './img/mobile-html5-banner.jpg',
                        imgUrl: './img/my-html5-banner-new.png',
                        offer: null,
                        game_name: '',
                        category_name: '',
                        //id: 34
                        id: 26

                    }
                ];

            if (arabicDomain) {
                htmlBannerData[0].imgUrl = './img/asiacell-html5-pc.png';
                htmlBannerDataMobile[0].imgUrl ='./img/asiacell-html5-mobile.png';
            }
            else if (kazakhDomain){
                htmlBannerData[0].imgUrl = './img/kazakh-html5-pc.jpg';
                htmlBannerDataMobile[0].imgUrl = './img/kazakh-html5-mobile.jpg';
            }
            else if(swedishDomain){
                htmlBannerData[0].imgUrl = './img/se-html5-pc.png';
                htmlBannerDataMobile[0].imgUrl = './img/se-html5-mobile.png';
            }
            else if(malasiyaDomain){
                htmlBannerData[0].imgUrl = './img/my-html5-banner-new.png';
                htmlBannerDataMobile[0].imgUrl = './img/my-html5-banner-new.png';
                htmlBannerData[0].id = 26;
                htmlBannerDataMobile[0].id = 26;
            }

            if (window.innerWidth <= 575) {
                bannerData = htmlBannerDataMobile;
            } else {
                bannerData = htmlBannerData;
            }
        }
        else if (this.state.gameType == 'video') {
            bannerData = [
                    {
                        imgUrl: './img/gamiclub-banner.png',
                        offer: null,
                        game_name: '',
                        category_name: '',
                        id: undefined
                    }
                ];
        }
        else {
            let androidBannerData, androidBannerDataMobile;
            androidBannerData = [
                    {
                        imgUrl: './img/android-banner.jpg',
                        offer: null,
                        game_name: '',
                        category_name: '',
                        id: 122
                    }
                ];
                androidBannerDataMobile = [
                    {
                        imgUrl: './img/mobile-android-banner.jpg',
                        offer: null,
                        game_name: '',
                        category_name: '',
                        id: 122
                    }
                ];

            if (arabicDomain){
                androidBannerData[0].imgUrl = './img/asiacell-android-pc-large.png';
                androidBannerDataMobile[0].imgUrl = './img/asiacell-android-mobile.png';
            }
            else if(kazakhDomain){
                androidBannerData[0].imgUrl = './img/kazakh-android-pc.jpg';
                androidBannerDataMobile[0].imgUrl = './img/kazakh-android-mobile.jpg';
            }
            else if(swedishDomain){
                androidBannerData[0].imgUrl = './img/se-android-pc.png';
                androidBannerDataMobile[0].imgUrl = './img/se-android-mobile.png';
            }
            if(config.subDomain == 'tr') {
                androidBannerData[0].imgUrl = './img/coffeebannerNew.jpg';
                androidBannerDataMobile[0].imgUrl = './img/coffeeBannerMobileNew.jpg';
                androidBannerData[0].id = 455;
                androidBannerDataMobile[0].id = 455;
            }
            
            if (window.innerWidth <= 575) {
                bannerData = androidBannerDataMobile;
            } else {
                bannerData = androidBannerData;
            }
        }

        const gamesParams = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            speed: 500,
        };
        const starIcon = '<svg class="isFavorite" width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.3328" y1="14" x2="25.6672" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.2078" y1="14" x2="25.7922" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="isFavorite" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg>',
        thumbsUpIcon = '<svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a1" gradientUnits="userSpaceOnUse" x1="0.5" y1="14" x2="24.5" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b1" gradientUnits="userSpaceOnUse" x1="0.375" y1="14" x2="24.625" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="st0" fill="url(#a1)" stroke="url(#b1)" stroke-width="100" d="M320 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zm160-512v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zm1184 0q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-129q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 .5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"/></svg>';
        return (
            <div className="home-page" >
                <Banner bannerData={bannerData} />
                {( (!isGamiclub && config.subDomain == 'no') || (isGamiclub && config.subDomain == 'ch') ) ? <button onClick={(e) =>{
                    sendData('', '', '', 'WA chat clicked');
                    window.open('https://wa.me/12028528006?text=Hello')
                } } className="whatsapp-button"> <img className="whatsapp-img" src="./img/whatsapp.png" /> </button> : null}
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <div className="category-options">
                                <div className="category-title-wrap text-uppercase">
                                    {
                                        (isGamiclub || isGameflares || isGamiway) ? 
                                        (this.state.gameType == 'android') ?
                                        <i className={`fa fa-android ${isGameflares ? 'fa-gradient-gameflares'  : isGamiway ? 'fa-gradient-gamiway':'fa-gradient-gamiclub'}` } aria-hidden="true"></i>
                                        :(this.state.gameType == 'html5') ? <i className={`fa fa-html5 ${isGameflares ? 'fa-gradient-gameflares' :isGamiway ? 'fa-gradient-gamiway':'fa-gradient-gamiclub'}`} aria-hidden="true"></i>
                                        :<i className={`fa fa-video-camera fa-gradient-gamiclub ${isGamiway ? 'fa-gradient-gamiway':null}`} aria-hidden="true"></i>
                                        : 
                                        (this.state.gameType == 'android') ? 
                                        <img className="category-title-icon" src="./img/icons/android.svg" alt={this.state.gameType} /> 
                                        : <img className="category-title-icon" src="./img/icons/html5.svg" alt={this.state.gameType} />

                                    }
                                    {(!this.state.switcherState) ?
                                        <span style={isGamiclub ? {color: 'lightgreen'} : isGameflares ? {color:'#FF394B'} :isGamiway ? {color:'#b347a0'} : null} className="category-type">
                                            <FormattedMessage id="topCategories"
                                                defaultMessage="Top Categories"
                                            />
                                        </span>
                                        : <span style={isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'} : null} className="category-type">
                                            <FormattedMessage id="favGames"
                                                defaultMessage="Favourite Games"
                                            />
                                        </span>
                                    }
                                </div>
                                {window.location.hostname.includes('vplay') ? null : 
                                <div className="fav-checkbox">
                                    <label className="switcher">
                                        <input type="checkbox" value={this.state.switcherState} onChange={this.toggleSwitcher} />
                                        <div className={isGamiclub ? "switcher__indicator__gamiclub" : isGameflares ? 'switcher__indicator__gameflares': isGamiway ? " switcher__indicator switcher__indicator__gamiway": "switcher__indicator"}></div>
                                        <span>
                                            <FormattedMessage id="favorites"
                                                defaultMessage="Favorites"
                                            />
                                        </span>
                                    </label>
                                </div>
                                }
                            </div>
                        </Col>
                    </Row>
                    {(!this.state.switcherState) ?
                        <div>
                            <Row>
                                <Col xs="12">
                                    <div className={isGamiclub ? "category-box-wrap-gamiclub" : "category-box-wrap" }>
                                        <CategoryList gametype={this.state.gameType} currentLanguage={config.lang}></CategoryList>
                                    </div>
                                </Col>
                            </Row>
                            {(this.props.categories.categories.length > 0) ?
                                this.props.categories.categories.map((category, index) => {
                                    if (category.categoryName.toLowerCase().indexOf('arcade') >= 0 && category.categoryTypeId === 2 && (config.subDomain == 'iq' || config.subDomain == 'asiacell')){
                                        return null;
                                    }
                                    else if (category.categoryTypeName.toLowerCase() == this.state.gameType) {
                                        return (
                                            <CategoryGames key={index} index={index} category={category} games={(this.props.games.games.length > 0 && this.props.games.games.filter((g) => { return g.categoryId == category.categoryId }).length > 0) ? this.props.games.games.filter((g) => { return g.categoryId == category.categoryId }) : []} onFavoriteClick={this.openGame} />
                                        )
                                    }
                                })
                                : ''}
                        </div>
                        : <Row className="game-list-row favorite-toggle-wrap">
                            {(this.props.games.favoriteGames.length > 0 && this.props.games.favoriteGames.filter((g) => { return g.gameType.toLowerCase() == this.state.gameType }).length > 0) ?
                                <Col xs="12">
                                    <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                                        {this.props.games.favoriteGames.filter((g) => { return g.gameType.toLowerCase() == this.state.gameType }).map((game) => {
                                            return (
                                                <div className="swiper-game-card">
                                                    <Card className={isGamiclub ? "game-card-gamiclub" : isGameflares ? "game-card gameflares-card-hover": isGamiway ? "game-card gamiway-card": "game-card"} onClick={this.openGame.bind(this, game)}>
                                                        <div className="game-card-inner">
                                                            <div className="game-thumb-wrap">
                                                                <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                            </div>
                                                            <div className="game-card-details">
                                                               {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">{game.gameTitle}</CardTitle>}
                                                               {window.location.hostname.includes('vplay') ? null : 
                                                                <div className="custom-rating isFavorite">
                                                                    <input id={'fav' + game.gameId} ref={'star' + game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite} />
                                                                    <label htmlFor={'fav' + game.gameId} className="isFavorite">
                                                                        <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'}  : isGamiway ? {color:'#b347a0'}:null} className="fa fa-star-o custom-star isFavorite"></i>
                                                                    </label>
                                                                </div>
                                                                }
                                                                <div className="game-card-left">
                                                                    <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'} : isGamiway ? {color:'#b347a0'} : null} className="fa fa-star custom-star"></i>} />
                                                                </div>
                                                                {(!window.location.hostname.includes('vplay') && config.subDomain != 'es') && 
                                                                <div className="game-card-right text-uppercase text-shadow text-right">
                                                                    {(game.gameType.toLowerCase() === "html5") ? <i className="fa fa-html5" aria-hidden="true"></i> : (game.gameType.toLowerCase() === "video") ? <i className="fa fa-video-camera" aria-hidden="true"></i> : <i className="fa fa-android" aria-hidden="true"></i>}</div>}
                                                                
                                                            </div>
                                                        </div>
                                                    </Card>
                                                </div>
                                            )
                                        })}
                                    </Swiper>
                                </Col>
                                : <Col xl="12" lg="12" md="12" sm="12" xs="12"> <p className="white-text-color no-game-text">
                                     {window.location.hash.includes('home/video') ? <FormattedMessage id="noFavVideosFound" defaultMessage="No favorite videos found." /> 
                                     : <FormattedMessage id="noFavGamesFound" defaultMessage="No favorite games found." />}
                                </p></Col>
                            }
                        </Row>}
                        {(config.subDomain=='id' || config.subDomain=='idsale' || config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && (!isGamiclub && !isGamiway) ?
                        <div>
                            <Row>
                                <Col xs="12" className="game-related-container">
                                    <div className="game-related-top">
                                        <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'} : isGameflares ?{borderBottom: '1px solid #FF394B'} :  null}>
                                            <h2 style = {isGamiclub ? {color: 'white', backgroundColor: 'green'} : isGameflares ? {color: 'white', backgroundColor: '#FF394B'} :  null} className="game-category-title"><i className="fa fa-video-camera" aria-hidden="true"></i>
                                            Financial Tips &amp; Tricks
                                            </h2>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="game-list-row">
                                <Col xs="12">
                                    <div className="swiper-wallpaper-card">
                                    <Card className={isGamiclub ? "wallpaper-card-gamiclub" : isGameflares ? "wallpaper-card wallpaper-card-gameflares" :  "wallpaper-card"} onClick={() => {window.open(`http://id.trendme.co/id/financial-tips-tricks/financial-tips-tricks/?uid=${this.props.access.uid}`)}}>
                                        <div className="wallpaper-card-inner">
                                            <div className="wallpaper-thumb-wrap">
                                                <CardImg className="wallpaper-thumb" style={{objectFit: 'cover', height: '150px', cursor: "pointer"}} alt="Financial Tips and Tricks" src="./img/idfinance.jpeg" />
                                            </div>
                                        </div>
                                    </Card>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        :
                        null
                        }
                       {config.subDomain=='za' && !this.state.switcherState && window.location.hash.includes('home/html') ? <Wallpapers/>:null}
                       {(config.subDomain=='es'||config.subDomain=='es2') && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_es}/>:null}
                       {config.subDomain=='no' && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_no}/>:null}
                       {config.subDomain=='kw' && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_kw}/>:null}
                       {config.subDomain=='qa' && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_qa}/>:null}
                       {config.subDomain=='ae' && !this.state.switcherState && window.location.hash.includes('home/html') && isGamiclub ? <Videos video={videos_ae}/>:null}
                       {config.subDomain=='eg' && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_eg}/>:null}
                       {config.subDomain=='rs' && !this.state.switcherState && window.location.hash.includes('home/html') && isGamiclub ? <Videos video={videos_rs}/>:null}
                       {config.subDomain=='cz' && !this.state.switcherState && window.location.hash.includes('home/video') && isGamiclub ? <Videos video={videos_cz}/>:null}
                       {config.subDomain=='gmn' && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_gmn}/>:null}
                       {config.subDomain=='ci' && !this.state.switcherState && window.location.hash.includes('home/html') && !isGamiclub ? <Videos video={videos_za_ci}/>:null}
                       {config.subDomain=='za' && !this.state.switcherState && window.location.hash.includes('home/video') && !isGamiclub ? <Videos video={videos_za}/>:null}
                       {(config.subDomain=='id' || config.subDomain=='idsale' || config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && (!isGamiclub && !isGamiway) ? <TextModal text={textContentShopee} />:null }
                       {(config.subDomain=='id' || config.subDomain=='idsale' || config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && (!isGamiclub && !isGamiway) ? <TextModal text={textContentIDRoblox} />:null}
                       {(config.subDomain=='id' || config.subDomain=='idsale' || config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && (!isGamiclub && !isGamiway) ?   <TextModal text={textContentIDSquidGames} /> :null}
                </Container>
            </div>
        );      
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        categories: state.CategoryReducer,
        games: state.GamesReducer,
        flashmessage: state.FlashMessageReducer,

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getGames,
        getFavouriteGames,
        setFavouriteGames,
        show,
        hide,
        showMessage,
        searchText
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js